/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// @ts-ignore
import * as runtime from '../runtime';
// @ts-ignore
import type {
// @ts-ignore
  Retailer,
// @ts-ignore
  RetailerCreateRequest,
// @ts-ignore
  RetailerListResponse,
// @ts-ignore
  RetailerUpdateRequest,
} from '../models/index';
// @ts-ignore
import {
// @ts-ignore
    RetailerFromJSON,
// @ts-ignore
    RetailerToJSON,
// @ts-ignore
    RetailerCreateRequestFromJSON,
// @ts-ignore
    RetailerCreateRequestToJSON,
// @ts-ignore
    RetailerListResponseFromJSON,
// @ts-ignore
    RetailerListResponseToJSON,
// @ts-ignore
    RetailerUpdateRequestFromJSON,
// @ts-ignore
    RetailerUpdateRequestToJSON,
} from '../models/index';

export interface CreateRetailerRequest {
    retailerCreateRequest: RetailerCreateRequest;
}

export interface DeleteRetailerRequest {
    id: string;
}

export interface GetRetailerRequest {
    id: string;
    include?: Array<string>;
    supplierId?: string;
}

export interface ListRetailersRequest {
    query?: string;
    supplierId?: string;
    include?: Array<string>;
    limit?: number;
    offset?: number;
    sortBy?: Array<string>;
    sortDirection?: Array<ListRetailersSortDirectionEnum>;
}

export interface UpdateRetailerRequest {
    id: string;
    retailerUpdateRequest: RetailerUpdateRequest;
}

/**
 * 
 */
export class RetailersApi extends runtime.BaseAPI {

    /**
     * Create a new retailer
     */
    async createRetailerRaw(requestParameters: CreateRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Retailer>> {
        if (requestParameters.retailerCreateRequest === null || requestParameters.retailerCreateRequest === undefined) {
            throw new runtime.RequiredError('retailerCreateRequest','Required parameter requestParameters.retailerCreateRequest was null or undefined when calling createRetailer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/retailers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetailerCreateRequestToJSON(requestParameters.retailerCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RetailerFromJSON(jsonValue));
    }

    /**
     * Create a new retailer
     */
    async createRetailer(requestParameters: CreateRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Retailer> {
        const response = await this.createRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a retailer by ID
     */
    async deleteRetailerRaw(requestParameters: DeleteRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteRetailer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/retailers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a retailer by ID
     */
    async deleteRetailer(requestParameters: DeleteRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRetailerRaw(requestParameters, initOverrides);
    }

    /**
     * Get a retailer by ID
     */
    async getRetailerRaw(requestParameters: GetRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Retailer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getRetailer.');
        }

        const queryParameters: any = {};

        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/retailers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RetailerFromJSON(jsonValue));
    }

    /**
     * Get a retailer by ID
     */
    async getRetailer(requestParameters: GetRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Retailer> {
        const response = await this.getRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all retailers
     */
    async listRetailersRaw(requestParameters: ListRetailersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetailerListResponse>> {
        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.supplierId !== undefined) {
            queryParameters['supplierId'] = requestParameters.supplierId;
        }

        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.sortBy) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sortDirection) {
            queryParameters['sortDirection'] = requestParameters.sortDirection;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/retailers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RetailerListResponseFromJSON(jsonValue));
    }

    /**
     * Get all retailers
     */
    async listRetailers(requestParameters: ListRetailersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetailerListResponse> {
        const response = await this.listRetailersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a retailer by ID
     */
    async updateRetailerRaw(requestParameters: UpdateRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRetailer.');
        }

        if (requestParameters.retailerUpdateRequest === null || requestParameters.retailerUpdateRequest === undefined) {
            throw new runtime.RequiredError('retailerUpdateRequest','Required parameter requestParameters.retailerUpdateRequest was null or undefined when calling updateRetailer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/retailers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RetailerUpdateRequestToJSON(requestParameters.retailerUpdateRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a retailer by ID
     */
    async updateRetailer(requestParameters: UpdateRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRetailerRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const ListRetailersSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListRetailersSortDirectionEnum = typeof ListRetailersSortDirectionEnum[keyof typeof ListRetailersSortDirectionEnum];
